import React from 'react'
import useMobile from '../../hooks/useMobile'
import HomeDesktop from './HomeDesktop'
import HomeMobileView from './components/HomeMobileView'

const Home = () => {
    const isMobile = useMobile()
    return isMobile ? <HomeMobileView /> : <HomeDesktop />
}

export default Home
